'use strict';
import isFinite from 'lodash/isFinite';
import {convertFromMinutes, convertToMinutes} from './TimeUtils';

DurationFormatterDirective.$inject = [];

export function DurationFormatterDirective() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      let unit;

      ngModel.$formatters.push(fromMinutes);

      ngModel.$parsers.push(toMinutes);

      attrs.$observe('durationFormatter', function (newUnit) {
        unit = newUnit;
        ngModel.$modelValue = ''; // no idea why this works. got idea from https://github.com/alexandernst/angular-unit-converter/blob/master/src/angular-unit-converter.js
      });

      function toMinutes(value) {
        if (!isFinite(value)) return value;
        const max = parseFloat(attrs.max);
        const result = convertToMinutes(value, unit);
        if (isFinite(max) && result > max) {
          // Prevent the user from inputting an invalid value
          ngModel.$viewValue = fromMinutes(max);
          ngModel.$render();
          return max;
        } else {
          return result;
        }
      }

      function fromMinutes(value) {
        return isFinite(value) ? convertFromMinutes(value, unit) : value;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/filters/DurationFormatterDirective.js